module.exports = __webpack_public_path__ + "media/images/social-share-button/odnoklassniki-cef3146ee2d5fdb32157ef3deb325f14.svg";